import React from 'react';
import { MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/content';
export function Footer() {
  return <footer className="bg-brand-deep" data-id="element-79" data-mp="3gg1025qei1yp">
      <div className="mx-auto max-w-letter px-4 py-5 text-center sm:px-6" data-id="element-80" data-mp="3gh3n22klrk9c">
        <p className="text-[0.7rem] font-semibold text-ink-onDarkMuted" data-id="element-81" data-mp="32pp4txyirn3c">
          © 2026 — Todos los Derechos Reservados.
        </p>
        <p className="mx-auto mt-1.5 max-w-2xl text-[0.66rem] font-medium leading-snug text-ink-onDarkMuted/80" data-id="element-82" data-mp="3ufa3s5xf73ls">
          Mega Pack Cámaras de Seguridad y Alarmas™ es un producto educativo. No
          sustituye formación profesional, práctica supervisada, normativa
          eléctrica, licencias, certificaciones, permisos ni el criterio de
          profesionales habilitados cuando corresponda. Toda instalación debe
          realizarse únicamente en sistemas propios o expresamente autorizados y
          respetando las normas de seguridad, electricidad y privacidad
          aplicables.
        </p>
        <p className="mt-2 text-[0.7rem] font-semibold text-white" data-id="element-83" data-mp="3l90lhpgqmmw3">
          <MailIcon size={12} className="mr-1 inline-block align-[-1px]" aria-hidden="true" data-id="element-84" data-mp="3lbdd6ucasbmc" />
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-gold transition-colors duration-150 ease-soft hover:text-white" data-id="element-85" data-mp="3v8hq03k96uqh">
            {SUPPORT_EMAIL}
          </a>
        </p>
        <nav aria-label="Enlaces legales" className="mt-1.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[0.7rem] font-semibold text-ink-onDarkMuted" data-id="element-86" data-mp="817cg38o1ksh">
          <a href="#terminos" className="transition-colors duration-150 ease-soft hover:text-gold" data-id="element-87" data-mp="hs1wr22cqaba">
            Términos y Condiciones
          </a>
          <span aria-hidden="true" data-id="element-88" data-mp="qub5bme27tm1">•</span>
          <a href="#privacidad" className="transition-colors duration-150 ease-soft hover:text-gold" data-id="element-89" data-mp="mrwqdddihe01">
            Política de Privacidad
          </a>
          <span aria-hidden="true" data-id="element-90" data-mp="tt9zef2oavwp">•</span>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="transition-colors duration-150 ease-soft hover:text-gold" data-id="element-91" data-mp="ytejef2si8ro">
            Contacto
          </a>
        </nav>
      </div>
    </footer>;
}